import {
    IconButton, Stack, MenuItem, InputAdornment, Grid, Box
} from '@mui/material';
import React from 'react';
import { Icon, Input, Selection } from '../../../../components/ui';
import { formatCurrency } from '../../../../services/ApiService';
import DollarInput from '../../../../components/Masks/DollarInput';
import RupiahInput from '../../../../components/Masks/RupiahInput';

const TabFreightSea = (props) => {
    const dataFreightStatus = [
        { id: 1, code: 'P', name: 'Prepaid' },
        { id: 2, code: 'C', name: 'Collect' },
    ];

    const AddFreightCollectOBL = (data) => {
        if (data === 'search') {
            props.setTitleModal('Freight Collect');
            props.setTipe(1);
            props.handleClick('Freight Collect');
        }
        else if (data === 'delete') {
            props.setFreightCollectIdOBL(0);
            props.setFreightCollectCodeOBL('');
            props.setFreightCollectNameOBL('');
        }
    };

    const AddFreightCollectHBL = (data) => {
        if (data === 'search') {
            props.setTitleModal('Freight Collect');
            props.setTipe(2);
            props.handleClick('Freight Collect');
        }
        else if (data === 'delete') {
            props.setFreightCollectIdHBL(0);
            props.setFreightCollectCodeHBL('');
            props.setFreightCollectNameHBL('');
        }
    };

    return (
        <>
            <Grid
                container
                spacing={'32px'}
            >
                <Grid
                    item
                    xl={6}
                    lg={6}
                    sm={6}
                    xs={12}
                >
                    <Box component="div" sx={{ marginTop: '12px' }}>
                        <Selection
                            id='0'
                            label={'Freight Status per OB/L'}
                            fullWidth={true}
                            placeholder={'Select Freight Status per OB/L'}
                            value={props.freightStatusOBL}
                            onChange={(e) => props.setFreightStatusOBL(e.target.value)}
                        >
                            {
                                dataFreightStatus.map((data, index) => (
                                    <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                ))
                            }
                        </Selection>

                        <Stack spacing={'16px'} direction="row" sx={{ marginTop: '16px' }}>
                            <Input
                                label="Freight Collect at"
                                value={props.freightCollectNameOBL && props.freightStatusOBL === 'C' ? props.freightCollectCodeOBL : ''}
                                disabled
                                formControlProps={{
                                    sx: {
                                        marginTop: '24px'
                                    }
                                }}
                                inputBaseProps={{
                                    readOnly: true,
                                }}
                            />

                            <Input
                                variant="standard"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                value={props.freightCollectNameOBL && props.freightStatusOBL === 'C' ? props.freightCollectNameOBL : ''}
                                type='text'
                                label={''}
                                disabled
                                formControlProps={{
                                    sx: {
                                        width: '100%',
                                    }
                                }}
                                inputBaseProps={{
                                    sx: {
                                        marginTop: '23px !important',
                                    },
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => AddFreightCollectOBL('delete')}
                                                hidden={props.freightCollectNameOBL && props.freightStatusOBL === 'C' ? false : true}
                                            >
                                                <Icon
                                                    iconName={'close'}
                                                    svgIconProps={{
                                                        fontSize: 'small',
                                                        htmlColor: '#0087C2',
                                                        sx: {
                                                            height: '12px',
                                                            width: '12px'
                                                        }
                                                    }}
                                                />
                                            </IconButton>

                                            <IconButton
                                                onClick={() => AddFreightCollectOBL('search')}
                                                hidden={props.freightStatusOBL === 'C' ? false : true}
                                            >
                                                <Icon
                                                    iconName={'search'}
                                                    svgIconProps={{
                                                        fontSize: 'small',
                                                        htmlColor: '#0087C2',
                                                        sx: {
                                                            height: '12px',
                                                            width: '12px'
                                                        }
                                                    }}
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Stack>

                        <Stack spacing={'16px'} direction="row" sx={{ marginTop: '16px' }}>
                            <Input
                                label="Payable By"
                                value={props.freightStatusOBL === 'C' ? props.payableAgentIdOBL : '0'}
                                onChange={(e) => props.setPayableAgentIdOBL(e.target.value)}
                                disabled
                                formControlProps={{
                                    sx: {
                                        marginTop: '24px'
                                    }
                                }}
                            />

                            <Input
                                label=""
                                value={props.freightStatusOBL === 'C' ? props.payableAgentNameOBL : ''}
                                onChange={(e) => props.setPayableAgentNameOBL(e.target.value)}
                                disabled
                                formControlProps={{
                                    sx: {
                                        marginTop: '24px',
                                        width: '100%'
                                    }
                                }}
                                inputBaseProps={{
                                    sx: {
                                        marginTop: '23px !important',
                                    },
                                }}
                            />
                        </Stack>

                        <Stack direction='row' spacing={'16px'} sx={{ marginTop: '16px' }}>
                            {
                                props.jobType.serviceType === 'Export' ?
                                    <>
                                        {props.selectCurrency(props.currency, props.setCurrency, 'Currency')}
                                    </>
                                    :
                                    <>
                                        {props.selectCurrency(props.OBLCurrency, props.setOBLCurrency, 'Amount')}

                                        <Input
                                            textAlign='right'
                                            value={props.OBLAmount}
                                            onChange={(e) => props.setOBLAmount(e.target.value)}
                                            formControlProps={{
                                                sx: {
                                                    width: '100%'
                                                }
                                            }}
                                            inputBaseProps={{
                                                sx: {
                                                    marginTop: '23px !important',
                                                },
                                                inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                                            }}
                                        />
                                    </>
                            }
                        </Stack>
                    </Box>
                </Grid>

                <Grid
                    item
                    xl={6}
                    lg={6}
                    sm={6}
                    xs={12}
                >
                    <Box component="div" sx={{ marginTop: '12px' }}>
                        <Selection
                            id='0'
                            label={'Freight HB/L'}
                            fullWidth={true}
                            placeholder={'Select Freight HB/L'}
                            value={props.freightStatusHBL}
                            onChange={(e) => props.setFreightStatusHBL(e.target.value)}
                        >
                            {
                                dataFreightStatus.map((data, index) => (
                                    <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                ))
                            }
                        </Selection>

                        <Stack spacing={'16px'} direction="row" sx={{ marginTop: '16px' }}>
                            <Input
                                label="Freight Collect at"
                                value={props.freightCollectNameHBL && props.freightStatusHBL === 'C' ? props.freightCollectCodeHBL : ''}
                                disabled
                                formControlProps={{
                                    sx: {
                                        marginTop: '24px'
                                    }
                                }}
                            />

                            <Input
                                variant="standard"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                value={props.freightCollectNameHBL && props.freightStatusHBL === 'C' ? props.freightCollectNameHBL : ''}
                                type='text'
                                label={''}
                                formControlProps={{
                                    sx: {
                                        width: '100%',
                                    }
                                }}
                                inputBaseProps={{
                                    sx: {
                                        marginTop: '23px !important',
                                    },
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => AddFreightCollectHBL('delete')}
                                                hidden={props.freightCollectNameOBL && props.freightStatusHBL === 'C' ? false : true}
                                            >
                                                <Icon
                                                    iconName={'close'}
                                                    svgIconProps={{
                                                        fontSize: 'small',
                                                        htmlColor: '#0087C2',
                                                        sx: {
                                                            height: '12px',
                                                            width: '12px'
                                                        }
                                                    }}
                                                />
                                            </IconButton>

                                            <IconButton
                                                onClick={() => AddFreightCollectHBL('search')}
                                                hidden={props.freightStatusHBL === 'C' ? false : true}
                                            >
                                                <Icon
                                                    iconName={'search'}
                                                    svgIconProps={{
                                                        fontSize: 'small',
                                                        htmlColor: '#0087C2',
                                                        sx: {
                                                            height: '12px',
                                                            width: '12px'
                                                        }
                                                    }}
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                                disabled
                            />
                        </Stack>

                        <Stack spacing={'16px'} direction="row" sx={{ marginTop: '16px' }}>
                            <Input
                                label="Payable By"
                                value={props.freightStatusHBL === 'C' ? props.payableConsigneeIdHBL : '0'}
                                onChange={(e) => props.setPayableAgentIdOBL(e.target.value)}
                                disabled
                                formControlProps={{
                                    sx: {
                                        marginTop: '24px'
                                    }
                                }}
                            />

                            <Input
                                label=""
                                value={props.freightStatusHBL === 'C' ? props.payableConsigneeNameHBL : ''}
                                onChange={(e) => props.setPayableAgentNameOBL(e.target.value)}
                                disabled
                                formControlProps={{
                                    sx: {
                                        marginTop: '24px',
                                        width: '100%'
                                    }
                                }}
                                inputBaseProps={{
                                    sx: {
                                        marginTop: '23px !important',
                                    },
                                }}
                            />
                        </Stack>

                        <Stack direction='row' spacing={'16px'} sx={{ marginTop: '16px' }}>
                            {
                                props.jobType.serviceType === 'Export' ?
                                    <Input
                                        label="Handling Information"
                                        value={props.handlingInf}
                                        onChange={(e) => props.setHandlingInf(e.target.value)}
                                        multiline
                                        fullWidth
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                            }
                                        }}
                                        inputBaseProps={{
                                            rows: 4,
                                            sx: {
                                                padding: '8px',
                                            },
                                        }}
                                    />
                                    :
                                    <>
                                        {props.selectCurrency(props.HBLCurrency, props.setHBLCurrency, 'Amount')}

                                        <Input
                                            textAlign='right'
                                            value={props.HBLAmount}
                                            onChange={(e) => props.setHBLAmount(e.target.value)}
                                            formControlProps={{
                                                sx: {
                                                    width: '100%'
                                                }
                                            }}
                                            inputBaseProps={{
                                                sx: {
                                                    marginTop: '23px !important',
                                                },
                                                inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                                            }}
                                        />
                                    </>
                            }
                        </Stack>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default TabFreightSea;